import { createI18n, type LocaleMessageValue, type VueMessageType } from 'vue-i18n';

export const DEFAULT_LANGUAGE = 'ru';
const STORAGE_KEY = 'check.language';

type Messages = Record<string, LocaleMessageValue<VueMessageType>>;

// Все locales/*.json из корня репозитория (общие с бэкендом).
// Новый язык = новый файл: он сам появится в availableLanguages.
const files = import.meta.glob<Messages>('@locales/*.json', {
  eager: true,
  import: 'default',
});

const messages: Record<string, Messages> = {};
for (const [file, content] of Object.entries(files)) {
  const lang = file.match(/([^/]+)\.json$/)?.[1];
  if (lang) messages[lang] = content;
}

export const availableLanguages = Object.keys(messages).sort();

function detectLanguage(): string {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && saved in messages) return saved;
  } catch {
    /* приватный режим и т.п. — просто идём дальше */
  }
  const browser = (navigator.language || '').slice(0, 2).toLowerCase();
  return browser in messages ? browser : DEFAULT_LANGUAGE;
}

/** Русские формы: «1 тренировка | 2 тренировки | 5 тренировок» — три варианта в сообщении. */
function russianPlural(choice: number, choicesLength: number): number {
  if (choicesLength < 3) return choice === 1 ? 0 : 1;
  const n = Math.abs(choice) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) return 2;
  if (n1 > 1 && n1 < 5) return 1;
  if (n1 === 1) return 0;
  return 2;
}

export const i18n = createI18n({
  legacy: false,
  locale: detectLanguage(),
  fallbackLocale: DEFAULT_LANGUAGE,
  messages,
  pluralRules: { ru: russianPlural },
});

/** Переключение языка до входа. После входа язык будет храниться в профиле на сервере (этап 8). */
export function setLanguage(lang: string) {
  if (!(lang in messages)) return;
  i18n.global.locale.value = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
}
